var map = {
	"./120-cash-bonus.svg": 97117,
	"./404-bg.svg": 52761,
	"./account-list-b.svg": 62303,
	"./account-list.svg": 14897,
	"./alpha-generation-1.svg": 42496,
	"./alpha-generation-2.svg": 5403,
	"./alpha-generation-3.svg": 23617,
	"./android.svg": 61247,
	"./app-store-icon.svg": 4695,
	"./apple.svg": 90730,
	"./archived.svg": 41050,
	"./arrow-down.svg": 58688,
	"./arrow-left.svg": 17209,
	"./arrow-next.svg": 5324,
	"./arrow-previous.svg": 27680,
	"./arrow-right.svg": 38900,
	"./back-arrow-blue.svg": 29658,
	"./back-arrow.svg": 16554,
	"./balance.svg": 32549,
	"./bank-statement.svg": 23155,
	"./bank_1.svg": 24797,
	"./bank_2.svg": 71031,
	"./bank_3.svg": 52675,
	"./bank_4.svg": 27496,
	"./cashback/account-unavailable.svg": 61644,
	"./cashback/available-bonus-card.svg": 13017,
	"./cashback/available-bonus.svg": 83629,
	"./cashback/cashback-redeemable.svg": 22540,
	"./cashback/how-it-works-slider.svg": 98250,
	"./cashback/i-blue.svg": 98857,
	"./cashback/i-white.svg": 28850,
	"./cashback/pending-cashback.svg": 56959,
	"./cashback/rejection.svg": 96734,
	"./cashback/successful.svg": 10758,
	"./cashback/total-cashback.svg": 62376,
	"./cashback/unavailable.svg": 25081,
	"./cashback/what-is-cashback-intro.svg": 23597,
	"./copy-icon.svg": 72010,
	"./copy-trading-follower.svg": 43221,
	"./copy-trading-provider.svg": 6746,
	"./copy.svg": 40935,
	"./crypto-deposit-failed.svg": 78961,
	"./crypto-deposit-successful.svg": 61115,
	"./dashboard.svg": 5307,
	"./demo.svg": 21696,
	"./deposit.svg": 63831,
	"./dots-mobile.svg": 85074,
	"./dots.svg": 32049,
	"./down.svg": 27739,
	"./driving-back.svg": 58956,
	"./driving-front.svg": 66947,
	"./driving-license.svg": 56960,
	"./dropdown-arrow-red.svg": 64280,
	"./facebook.svg": 65925,
	"./funding/bankwire-mob.svg": 50659,
	"./funding/bankwire.svg": 69741,
	"./funding/bitcoin-mob.svg": 53413,
	"./funding/bitcoin.svg": 74544,
	"./funding/lydiax-mob.svg": 15069,
	"./funding/lydiax.svg": 70422,
	"./funding/neteller.svg": 8940,
	"./funding/skrill.svg": 50559,
	"./funding/visa-mastercard-powercash.svg": 34700,
	"./funding/visa-mastercard-safecharge.svg": 27095,
	"./funding/visa-mastercard.svg": 99779,
	"./funding/vload-mob.svg": 5449,
	"./funding/vload.svg": 45959,
	"./go-back.svg": 27102,
	"./gold.svg": 81305,
	"./google-play-icon.svg": 14420,
	"./icons/arrow-back-circle-outline.svg": 18813,
	"./icons/arrow-forward-circle-outline.svg": 59709,
	"./icons/card.svg": 95552,
	"./icons/chevron-down.svg": 29116,
	"./icons/chevron-right.svg": 73694,
	"./icons/competitions/arrow-down.svg": 693,
	"./icons/competitions/arrow-up.svg": 78176,
	"./icons/competitions/competition-ends-fin.svg": 77045,
	"./icons/competitions/contestants-fin.svg": 7090,
	"./icons/competitions/contestants.svg": 81648,
	"./icons/competitions/current-leader.svg": 28438,
	"./icons/competitions/mt-4.svg": 56568,
	"./icons/competitions/mt-5.svg": 18686,
	"./icons/competitions/prize-pool-competition-main-icon-finished.svg": 23965,
	"./icons/competitions/prize-pool-competition-main-icon-upcoming.svg": 29911,
	"./icons/competitions/prize-pool-competition-main-icon.svg": 16300,
	"./icons/competitions/prize-pool.svg": 94812,
	"./icons/competitions/prize1.svg": 52306,
	"./icons/competitions/prize2.svg": 2617,
	"./icons/competitions/prize3.svg": 8957,
	"./icons/competitions/prize4.svg": 19318,
	"./icons/competitions/prize5.svg": 47088,
	"./icons/competitions/registration-ends-fin.svg": 57646,
	"./icons/competitions/registration-ends.svg": 16786,
	"./icons/competitions/search-icon.svg": 74308,
	"./icons/competitions/successful.svg": 24310,
	"./icons/competitions/time-remaining-fin.svg": 41625,
	"./icons/competitions/time-remaining.svg": 62587,
	"./icons/competitions/trading-competition-dashboard-graphic.svg": 50418,
	"./icons/competitions/try-again.svg": 29867,
	"./icons/devices/android.svg": 73313,
	"./icons/devices/ios.svg": 21471,
	"./icons/devices/windows.svg": 48178,
	"./icons/footer/facebook.svg": 1142,
	"./icons/footer/linkedin.svg": 16748,
	"./icons/footer/lqdslogan.svg": 38592,
	"./icons/footer/social-facebook.svg": 55846,
	"./icons/footer/social-gplus.svg": 54850,
	"./icons/footer/social-instagram.svg": 12700,
	"./icons/footer/social-linkedin.svg": 49775,
	"./icons/footer/social-twitter.svg": 15050,
	"./icons/footer/twitter.svg": 47658,
	"./icons/graph.svg": 39006,
	"./icons/group.svg": 5911,
	"./icons/line-graph.svg": 9969,
	"./icons/newsfeed/arrow.svg": 27174,
	"./icons/newsfeed/like-blk.svg": 7533,
	"./icons/newsfeed/like-red.svg": 75271,
	"./icons/newsfeed/newsfeed.svg": 84218,
	"./icons/newsfeed/profile-pic.svg": 93334,
	"./icons/newsfeed/time.svg": 89725,
	"./icons/partners.svg": 25395,
	"./icons/profile-head.svg": 58038,
	"./icons/profile.svg": 86913,
	"./icons/quick-menu/account-list.svg": 56495,
	"./icons/quick-menu/bonus.svg": 53571,
	"./icons/quick-menu/change-password.svg": 46685,
	"./icons/quick-menu/clients.svg": 96391,
	"./icons/quick-menu/demo-account.svg": 49136,
	"./icons/quick-menu/deposit.svg": 19843,
	"./icons/quick-menu/download.svg": 73432,
	"./icons/quick-menu/ebooks.svg": 1192,
	"./icons/quick-menu/internal-transfer.svg": 43170,
	"./icons/quick-menu/live-account.svg": 60872,
	"./icons/quick-menu/marketing-material.svg": 28715,
	"./icons/quick-menu/mycards.svg": 73689,
	"./icons/quick-menu/new-master.svg": 53713,
	"./icons/quick-menu/overview.svg": 26450,
	"./icons/quick-menu/pamm-stats.svg": 78894,
	"./icons/quick-menu/pamm.svg": 98068,
	"./icons/quick-menu/partners.svg": 67590,
	"./icons/quick-menu/payment-history.svg": 93881,
	"./icons/quick-menu/profile.svg": 25567,
	"./icons/quick-menu/sub-ibs.svg": 8763,
	"./icons/quick-menu/upload.svg": 89957,
	"./icons/quick-menu/video-courses.svg": 14607,
	"./icons/quick-menu/withdraw.svg": 41401,
	"./icons/quickmenu-small.svg": 75021,
	"./icons/quickmenu.svg": 91462,
	"./icons/upload/address-proof.svg": 98454,
	"./icons/upload/approved.svg": 62379,
	"./icons/upload/arrow-down.svg": 85171,
	"./icons/upload/arrow-up.svg": 30883,
	"./icons/upload/cc-back.svg": 89569,
	"./icons/upload/cc-front.svg": 14617,
	"./icons/upload/id-back.svg": 29869,
	"./icons/upload/id-front.svg": 70229,
	"./icons/upload/info.svg": 95124,
	"./icons/upload/other.svg": 10089,
	"./id-card-back.svg": 52733,
	"./id-card-front.svg": 83023,
	"./identity-card.svg": 73518,
	"./info.svg": 85533,
	"./instagram.svg": 37927,
	"./internal-transfer-b.svg": 36127,
	"./internal-transfer-quickmenu.svg": 28142,
	"./internal-transfer.svg": 39917,
	"./islamic.svg": 34727,
	"./linkedin.svg": 26167,
	"./livechat.svg": 88139,
	"./local-depositor-icon.svg": 39324,
	"./local-depositor.svg": 87400,
	"./login/plexy-login-blue.svg": 59035,
	"./login/plexy-login-dots.svg": 8758,
	"./login/plexy-login-yellow.svg": 649,
	"./logo_white_green.svg": 27412,
	"./logos/social-facebook.svg": 88074,
	"./logos/social-gplus.svg": 45089,
	"./logos/social-linkedin.svg": 4346,
	"./logos/social-twitter.svg": 74938,
	"./menu-hamburger.svg": 32502,
	"./menu-settings.svg": 2046,
	"./metatrader4.svg": 22411,
	"./metatrader5.svg": 51063,
	"./micro.svg": 33584,
	"./minus-icon.svg": 66943,
	"./mt4-not-selected.svg": 7070,
	"./mt4-pamm.svg": 38791,
	"./mt4-selected.svg": 2134,
	"./mt4.svg": 26768,
	"./mt5-not-selected.svg": 63038,
	"./mt5-pamm.svg": 78629,
	"./mt5-selected.svg": 8163,
	"./mt5.svg": 9116,
	"./my-settings-icon-b.svg": 28662,
	"./my-settings-icon.svg": 19376,
	"./my-settings.svg": 11542,
	"./next-arrow-2.svg": 96043,
	"./no-deposit-bonus.svg": 78735,
	"./pamm-dashboard.svg": 42439,
	"./pamm-investor.svg": 54189,
	"./pamm-not-selected.svg": 97945,
	"./pamm-selected.svg": 32371,
	"./pamm.svg": 84486,
	"./partners-arrow-previous.svg": 700,
	"./partners-icon.svg": 72622,
	"./partners.svg": 64367,
	"./passport.svg": 19230,
	"./passport_preview.svg": 86496,
	"./platform-dropdown.svg": 37226,
	"./platinum.svg": 92480,
	"./plexytrade-favicon.svg": 81820,
	"./plexytrade-login-bg.svg": 67856,
	"./plexytrade-logo-white.svg": 27627,
	"./plexytrade-logo.svg": 36454,
	"./plus-icon.svg": 31538,
	"./previous-arrow-2.svg": 29089,
	"./promo/vload/account.svg": 18643,
	"./promo/vload/evoucher.svg": 40842,
	"./promo/vload/tier2.svg": 46041,
	"./promo/vload/vload-logo.svg": 88185,
	"./raw-bonus.svg": 57278,
	"./settings-eye-hidden.svg": 14672,
	"./settings-eye-shown.svg": 8236,
	"./silver-islamic.svg": 28005,
	"./silver.svg": 20014,
	"./tick.svg": 38116,
	"./total-clients.svg": 27804,
	"./total-deposits.svg": 48079,
	"./total-earned.svg": 88726,
	"./total-paid.svg": 77526,
	"./total-sub-ibs.svg": 39346,
	"./total-withdrawals.svg": 2701,
	"./tradelocker-not-selected.svg": 24018,
	"./tradelocker-selected.svg": 54062,
	"./tradelocker.svg": 38439,
	"./trading-central-homepage-mobile.svg": 20682,
	"./trading-central-homepage.svg": 4600,
	"./trading-competition.svg": 6850,
	"./trading.svg": 41800,
	"./transactions-icon-b.svg": 82357,
	"./transactions-icon.svg": 18476,
	"./transactions.svg": 9353,
	"./twitter.svg": 8505,
	"./two-factor-popup-icon.svg": 87392,
	"./up.svg": 42887,
	"./upgrade-to-live.svg": 46873,
	"./upload-your-documents.svg": 78470,
	"./utility-bill.svg": 7816,
	"./utility_1.svg": 95235,
	"./utility_2.svg": 85236,
	"./utility_3.svg": 64506,
	"./video-courses-b.svg": 28261,
	"./video-courses.svg": 58386,
	"./view-graph-icon.svg": 82430,
	"./vps.svg": 65913,
	"./webtrader.svg": 86054,
	"./windows.svg": 57248,
	"./withdraw.svg": 98248
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 58278;